<template>
  <div class="page-content">
    <div class="page-title">How to Become Member</div>
    <div class="sub-title" style="line-height: 27px">
      Article 1 - Any structure wishing to join the World Federation as a Full member or Associate
      member must submit:
    </div>
    <div class="text">
      (a) <span style="margin-right: 15px"></span>A request for membership to the President of the
      World Federation along with a brief description of the structure and list of its members with
      addresses;
      <br />
      <br />
      (b) <span style="margin-right: 15px"></span>A letter of recommendation from the National
      Commission for UNESCO of its country.
      <br />
      <br />
      The request shall be examined by the Secretariat, before presenting it at the next session of
      the Executive Board.
      <br />
      Provisional admission or refusal shall be determined by the Executive Board. Applicants shall
      be notified in writing by the President of the decision of the Executive Board. Final
      admission shall be determined by the World Congress.
      <br />
      In case of the provisional admission, applicant shall be asked to pay the required membership
      fee within 60 days or at the time of World Congress, whichever is earlier.
      <br />
    </div>
    <div class="sub-title">Article 2 – Disputes Procedure</div>
    <div class="text">
      1. Should an applicant for membership disagree with the decision made by the Executive Board
      on the application or believe that insufficient or unfounded reasons were given for a
      rejection, the applicant may request a hearing before the Credentials Committee at the next
      World Congress; the Committee will then make its own recommendation which it will put before
      the World Congress for a final decision.
      <br />
      2. Applications for a hearing before the Credentials Committee and the World Congress must be
      sent in writing to the Secretary General at least two months before the World Congress and not
      more than three months after the applicant was notified of the decision of the Executive
      Board.
    </div>

    <div class="sub-title">Article 3 - Withdrawal of Members</div>
    <div class="text">
      1. The Secretary General shall be notified in writing of a member's intention to withdraw from
      the organization, and shall acknowledge receipt of the notification. In accordance with the
      Constitution, he shall indicate the date from which the withdrawal becomes effective. The
      member must fulfil his financial obligations before his departure date (eventually debts and
      contribution for the actual year).
      <br />
      2. The rights and duties of a withdrawing member shall remain unchanged until his withdrawal
      becomes effective, one year after the date at which notification of the intention to withdraw
      is received.
      <br />
      3. The rights of any withdrawing member whose financial obligations have not been settled by
      the date at which the withdrawal takes effect, will automatically be suspended.
    </div>
    <div class="sub-title">Article 4 – Expulsion of members</div>
    <div class="text">
      1. The expulsion of any member is announced by the Congress. This point must be explicitly
      included on the agenda of the World Congress, together with the precision of the identity of
      the member involved.
      <br />
      2. The Executive Board shall put before the World Congress a detailed report concerning the
      reasons for the expulsion of a member.
      <br />
      3. During any debate at the World Congress concerning the expulsion of a member, the member
      has the right to a hearing and to speak in its own defence in the last instant, before the
      final vote.
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
